import { render, staticRenderFns } from "./ExchangeCodeCard.vue?vue&type=template&id=772d46ce&scoped=true"
import script from "./ExchangeCodeCard.vue?vue&type=script&lang=js"
export * from "./ExchangeCodeCard.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCodeCard.vue?vue&type=style&index=0&id=772d46ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d46ce",
  null
  
)

export default component.exports